module.exports = __webpack_public_path__ + "img/ereszkalkulator_haz_005_szines.fd4b0751.png";